<template>
  <section class="container-fluid white-box">
    <form ref="form">
      <div class="row">
        <div class="col-md-12">
          <h2>Owner Information</h2>
          <p class="sub-text">
            Who are you and what is the best way to contact you?
          </p>
        </div>
        <div class="col-sm-6 form-group">
          <!-- <label for=""></label> -->
          <input
            v-model="first_name"
            required
            type="firstname"
            class="form-control"
            id="first-name"
            aria-describedby="first-name"
            placeholder="First Name"
          />
        </div>
        <div class="col-sm-6 form-group">
          <!-- <label for=""></label> -->
          <input
            v-model="last_name"
            required
            type="lastname"
            class="form-control"
            id="last-name"
            aria-describedby="last-name"
            placeholder="Last Name"
          />
        </div>
        <div class="col-md-12 form-group">
          <!-- <label for="email">Email address</label> -->
          <input
            v-model="email"
            required
            type="email"
            class="form-control"
            id="owner-email"
            aria-describedby="ownerEmail"
            placeholder="Email"
          />
        </div>
        <div class="col-md-12 form-group">
          <input
            v-model="phone"
            required
            type="text"
            class="form-control"
            id="owner-phonenumber"
            aria-describedby="phoneNumber"
            placeholder="Phone Number"
          />
        </div>
        <div class="col-md-12 d-flex justify-content-end">
          <button class="next-button" type="submit" name="next" @click="next">
            Next
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
// import axios from 'axios';
// import OrderReceipt from '@/components/HomeContainer.vue'
export default {
  name: "OwnerInfoPage",
  components: {},
  props: {
    first_name_: String,
    last_name_: String,
    phone_: String,
    email_: String,
  },
  data() {
    return {
      first_name: this.first_name_,
      last_name: this.last_name_,
      phone: this.phone_,
      email: this.email_,
    };
  },
  methods: {
    next() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
      }
      this.$emit("next-clicked", this.$data);
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>

<style scoped>
.container-fluid {
  margin-bottom: 75px !important;
}

button {
  /* margin-left: 24px;
  margin-top: 24px; */
  margin-left: 2.22vh;
  margin-top: 2.22vh;
}
</style>
